import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  // Auto-submit form when select changes
  handleSelectChange(event) {
    const input = event.target;
    const form = input.closest("form");
    if (!form) return;

    form.requestSubmit();
  }
}
